import React, { useState } from "react";
import { Card, Row, Col, Divider, Modal, Button, Input, Form, message } from "antd";
import emailjs from "emailjs-com"; // Ensure EmailJS is installed: npm install emailjs-com
import "./BatchScheduel1.css";
import cImage from "../assets/images/batchtimer.jpg";

const BatchScheduel = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(""); // Track selected course/batch
  const [form] = Form.useForm();

  // const getNextStartDate = () => {
  //   const today = new Date();
  //   today.setDate(today.getDate() + 8);
  //   const day = today.getDate();
  //   const month = today.toLocaleString("default", { month: "short" });
  //   const year = today.getFullYear().toString().slice(-2);
  //   return `${day} ${month} '${year}`;
  // };

  const data = [
    {
      key: "1",
      batchName: "Java Programming",
      image: cImage,
      startDate: "1 Jan'26",
      endDate: "31 Mar '26",
      timings: "16:00-17:00",
      days: "Monday to Friday",
      mode: "Offline",
    },
    {
      key: "2",
      batchName: "Python Programming",
      image: cImage,
      startDate: "8 Dec'25",
      endDate: "15 Mar '26",
      timings: "17:00-18:00",
      days: "Monday to Friday",
      mode: "Offline",
    },
   {
      key: "3",
      batchName: "Linux Fundamentals",
      image: cImage,
      startDate: "18th Dec'25",
      endDate: "31st Jan'26",
      timings: "8:00-9:00",
      days: "Monday to Friday",
      mode: "Online",
    },
    {
       key: "4",
       batchName: "Cloud Computing",
       image: cImage,
       startDate: "1 Apr'26",
       endDate: "30 May'26",
       timings: "08:00-9:00",
       days: "Mon-Fri",
       mode: "Online",
     },
  ];

  const showModal = (batchName) => {
    setSelectedBatch(batchName); // Set selected batch
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleFormSubmit = (values) => {
    const emailParams = {
      name: values.name,
      email: values.email,
      phone: values.phone,
      selectedCourse: selectedBatch, // Include selected batch
    };

    emailjs
      .send(
        'service_oit4bk9', // Replace with your EmailJS service ID
                'template_xny0vd6', // Replace with your EmailJS template ID
                emailParams,
                '6xlgr_2EFvcPEjnDG' // Replace with your EmailJS public key
      )
      .then(
        () => {
          message.success(`Application submitted for ${selectedBatch}`);
          setIsModalVisible(false);
          form.resetFields();
        },
        (error) => {
          console.error("EmailJS Error:", error);
          message.error("Failed to submit application. Please try again.");
        }
      );
  };

  return (
    <div className="batch-schedule-container">
      {/* Header Image */}
      <div className="batch-schedule-header">
        <img
          src={require("../assets/images/Batch-Schedule.webp")}
          alt="Batch Schedule Header"
          className="header-image"
        />
      </div>

      {/* Divider */}
      <Divider style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
        Current Batch Schedule
      </Divider>
      <Divider style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
        Details of the existing/upcoming batches
      </Divider>

      {/* Cards for Batches */}
      <Row gutter={[24, 16]}>
        {data.map((batch) => (
          <Col xs={24} sm={12} md={12} lg={12} xl={12} key={batch.key}>
            <Card
              title={batch.batchName}
              bordered={true}
              className="batch-card"
              cover={<img alt={batch.batchName} src={batch.image} />}
              extra={
                <Button
                  type="primary"
                  onClick={() => showModal(batch.batchName)}
                >
                  Apply
                </Button>
              }
            >
              <p>
                <strong>Start Date:</strong> {batch.startDate}
              </p>
              <p>
                <strong>End Date:</strong> {batch.endDate}
              </p>
              <p>
                {/* <strong>Timings:</strong> {batch.timings} */}
              </p>
              <p>
                <strong>Days:</strong> {batch.days}
              </p>
              <p>
                <strong>Mode:</strong> {batch.mode}
              </p>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Modal for Application */}
      <Modal
        title={`Apply for ${selectedBatch}`}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form form={form} onFinish={handleFormSubmit} layout="vertical">
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please enter your name!" }]}
          >
            <Input placeholder="Enter your name" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter your email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
          >
            <Input placeholder="Enter your email" />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="phone"
            rules={[
              { required: true, message: "Please enter your phone number!" },
              { pattern: /^[0-9]{10}$/, message: "Please enter a valid phone number!" },
            ]}
          >
            <Input placeholder="Enter your phone number" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>

    </div>
  );
};

export default BatchScheduel;
